import React, { useEffect, useState } from "react";


import { Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";

import "./styles/app.scss";
import { DataProvider } from "./context/DataProvider";
import HomePage from "./pages/HomePage";
import LEDView from "./pages/LEDView";
import ResponsiveView from "./pages/ResponsiveView";


// directory profile

function App() {
  const { pathname } = useLocation();

  
  return (
    <DataProvider>
      <Routes>
        <Route
          path="/natrium/interactive-display"
          element={<ResponsiveView />}
        />
        <Route path="/natrium/interactive-display/led" element={<LEDView />} />
        <Route
          path="/natrium/interactive-display/responsive"
          element={<ResponsiveView />}
        />
      </Routes>
    </DataProvider>
  );
}

export default App;
